export const LOGIN = '/login';
export const SIGNUP = '/signup';
export const SIGNUP_SET_PASSWORD = '/signup/set-pass/:email/:otp';
export const FORGOT_PASSWORD = '/forgot-password';
export const ESTIMATOR = '/estimator';

export const HOME = '/';
export const DASHBOARD = '/';

export const COMPONENTS = '/components';

export const TEAM = '/team';
export const STAFF = '/staff';
export const STAFF_SET_PASSWORD = '/me/set-pass/:email/:otp';
export const JOIN_ORG = '/join-org';
export const PROFILE = '/profile';
export const WALLET = '/wallet';
export const CHANGE_PASSWORD = '/change-password';
export const PAYMENT_METHOD = '/wallet/payment-methods';

export const ADVERTISERS = '/library/advertisers';
export const CREATE_ADVERTISER = '/library/advertisers/create';

export const AUDIENCES = '/library/audiences';
export const CREATE_AUDIENCE = '/library/audiences/create';
export const CREATE_AUDIENCE_CUSTOM = '/library/audiences/custom';
export const CREATE_AUDIENCE_STANDARD = '/library/audiences/standard';
export const CREATE_PERSONAL_DATA_TARGETING =
  '/library/audiences/personal-data-targeting';
export const CREATE_AUDIENCE_RETARGETING = '/library/audiences/retargeting';

export const EDIT_AUDIENCE = '/library/audiences-detail-update/:id';
export const EDIT_AUDIENCE_CUSTOM =
  '/library/audiences-detail-update/custom/:id';
export const EDIT_AUDIENCE_STANDARD =
  '/library/audiences-detail-update/standard/:id';
export const EDIT_PERSONAL_DATA_TARGETING =
  '/library/audiences-detail-update/personal-data-targeting/:id';
export const EDIT_AUDIENCE_RETARGETING =
  '/library/audiences-detail-update/retargeting/:id';

export const CREATIVES = '/library/creatives';
export const UPLOAD_CREATIVES = '/library/creatives/upload';

export const MY_LIBRARY = '/library/my-library';
export const CAMPAIGN_SNAPSHOT = '/campaign-snapshot/:id';
export const AD_DETAILS = '/ad-details/:id';
export const AUDIENCE_DETAIL = '/library/audiences-detail/:id';
export const CREATE_CREATIVE = '/library/creatives/new';
export const CREATIVES_DETAIL = '/library/creatives-detail/:id';
export const STORE_TEMPLATE = '/templates';
export const STORE_TEMPLATE_DETAIL = '/template/:id';

export const PURCHASED_TEMPLATE = '/library/purchased-template';
export const PURCHASED_TEMPLATE_DETAIL = '/library/purchased-template/:id';
export const CART = '/cart';
export const CHECKOUT = '/checkout';

export const SUPPORT = '/support';

// Campaign
export const CAMPAIGNS = '/campaigns';
export const CREATE_CAMPAIGN = '/campaign/new/:step/';
export const CREATE_DRAFT_CAMPAIGN = '/campaign/create/:step/:id';
export const EDIT_CAMPAIGN = '/campaign/edit/:step/:id';
export const CAMPAIGN_DETAIL = '/campaign/:id';

// Stared Page
export const STARTED_PAGE = '/started';
export const ANALYTICS = '/:accountRole/analytics';
export const ANALYTIC_DETAIL = '/:accountRole/analytic/:id';
export const SHARED_ANALYTIC = '/shared/analytics';
